import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
    return useContext(ThemeContext);
};

export const ThemeProvider = ({ children }) => {
    const storedTheme = localStorage.getItem('theme') || 'light';
    const [theme, setTheme] = useState(storedTheme); // default theme

    

    const toggleTheme = () => {        
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme); // Persist theme in localStorage
    };

    // Apply the current theme to the body class
    useEffect(() => {
        document.body.classList.remove('light', 'dark'); // Remove both themes
        document.body.classList.add(theme); // Add the current theme class
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>            
            {children}
        </ThemeContext.Provider>
    );
};